import { DocumentTitleHandler as LegacyDocumentTitleHandler } from "@refinedev/react-router-v6";
import type { ComponentProps, FC } from "react";
import { useTranslation } from "utils";

interface IDocumentTitleHandler {
  title?: string;
}
export const DocumentTitleHandler: FC<IDocumentTitleHandler> = ({ title }) => {
  const { t } = useTranslation("common");
  const handler: ComponentProps<
    typeof LegacyDocumentTitleHandler
  >["handler"] = ({ resource }) => {
    const resourceName = resource?.name;
    let metaTitle = "";
    if (resourceName) {
      metaTitle = t(`${resourceName}.${resourceName}`);
      if (title) metaTitle += " - " + title;
    } else if (title) {
      metaTitle = title;
    }
    return metaTitle;
  };
  return <LegacyDocumentTitleHandler handler={handler} />;
};
